// Polyfill for crypto.randomUUID in non-secure contexts (HTTP)
// This MUST run before any other imports that might use crypto.randomUUID
if (typeof crypto !== 'undefined' && typeof crypto.randomUUID !== 'function') {
  // @ts-expect-error - Polyfill for non-secure contexts
  crypto.randomUUID = function randomUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { SmoothScrollProvider } from './components/SmoothScroll';
import { NexusToastProvider } from './utils/toast';
import 'lenis/dist/lenis.css';
import './index.css';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: true, // Always refetch when component mounts
      refetchOnReconnect: true, // Refetch when network reconnects
      retry: 1,
      staleTime: 0, // Data is immediately stale - always refetch on mount
      gcTime: 5 * 60 * 1000, // Keep unused data in cache for 5 minutes (was cacheTime in v4)
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <SmoothScrollProvider>
          <NexusToastProvider>
            <App />
          </NexusToastProvider>
        </SmoothScrollProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);
